/* tslint:disable */
/* eslint-disable */
/* @relayHash cb97fef7c5a360ba1ef36b1ca2c33de2 */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type App_SignoffRequestsPage_QueryVariables = {
    limit?: number | null;
};
export type App_SignoffRequestsPage_QueryResponse = {
    readonly signoffRequests: {
        readonly " $fragmentRefs": FragmentRefs<"SupervisorSignOffPage_signoffRequests">;
    } | null;
};
export type App_SignoffRequestsPage_Query = {
    readonly response: App_SignoffRequestsPage_QueryResponse;
    readonly variables: App_SignoffRequestsPage_QueryVariables;
};



/*
query App_SignoffRequestsPage_Query(
  $limit: Int
) {
  signoffRequests(page: {limit: $limit}) {
    ...SupervisorSignOffPage_signoffRequests
  }
}

fragment SupervisorSignOffPage_signoffRequests on SignoffRequestPage {
  edges {
    id
    createdAt
    title
    PDFURL
    approval
    candidate {
      firstName
      lastName
      id
    }
    entries {
      edges {
        fileUrl
        id
      }
      pageInfo {
        total
      }
    }
    placement {
      name
      id
    }
  }
  pageInfo {
    total
    offset
    limit
    given
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "limit",
            "type": "Int",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "ObjectValue",
            "name": "page",
            "fields": [
                {
                    "kind": "Variable",
                    "name": "limit",
                    "variableName": "limit"
                }
            ]
        } as any)
    ], v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "total",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "App_SignoffRequestsPage_Query",
            "type": "Query",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "signoffRequests",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "SignoffRequestPage",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "SupervisorSignOffPage_signoffRequests",
                            "args": null
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "App_SignoffRequestsPage_Query",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "signoffRequests",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "SignoffRequestPage",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "SignoffRequest",
                            "plural": true,
                            "selections": [
                                (v2 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "createdAt",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "title",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "PDFURL",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "approval",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "candidate",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Candidate",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "firstName",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "lastName",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        (v2 /*: any*/)
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "entries",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "EntryPage",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "edges",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "QWEEntry",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "fileUrl",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                (v2 /*: any*/)
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "pageInfo",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "PageInfo",
                                            "plural": false,
                                            "selections": [
                                                (v3 /*: any*/)
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "placement",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Placement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "name",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        (v2 /*: any*/)
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "pageInfo",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "PageInfo",
                            "plural": false,
                            "selections": [
                                (v3 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "offset",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "limit",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "given",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "App_SignoffRequestsPage_Query",
            "id": null,
            "text": "query App_SignoffRequestsPage_Query(\n  $limit: Int\n) {\n  signoffRequests(page: {limit: $limit}) {\n    ...SupervisorSignOffPage_signoffRequests\n  }\n}\n\nfragment SupervisorSignOffPage_signoffRequests on SignoffRequestPage {\n  edges {\n    id\n    createdAt\n    title\n    PDFURL\n    approval\n    candidate {\n      firstName\n      lastName\n      id\n    }\n    entries {\n      edges {\n        fileUrl\n        id\n      }\n      pageInfo {\n        total\n      }\n    }\n    placement {\n      name\n      id\n    }\n  }\n  pageInfo {\n    total\n    offset\n    limit\n    given\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = 'c7419cb3f334b488e75528e8d59c01b1';
export default node;
